<template>
    <div class="infopage">
        <div class="infowrap" v-for="(item,index) in infolist" :key="item.id">
            <div :class="['infobox',((index %2 )==0)?'doublerow':'singlerow']" v-if="item.parinfokindkv<999">

                <div class="infosub realwrap infosubcontactwrap" v-if="item.parinfokindkv==10">
                    <div class="infosubcontact">
                        <div class="subtitle" v-if="item.parinfokindkv!=9"><div class="word">{{$common.langinfo(item.title,item.title_en)}}</div></div>
                        <div class="editor2" v-html="$common.langinfo(item.content,item.content_en)"></div>
                    </div>
                    <div class="infosub2 infosubmap">
                        <iframe width="100%" height="400" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="http://j.map.baidu.com/s/q87HFb"></iframe>
                    </div>
                </div>
                <div class="infosub realwrap" v-else>
                    <template v-if="item.imgs">
                        <div class="infosub1">
                            <div class="subtitle" v-if="item.parinfokindkv!=9"><div class="word">{{$common.langinfo(item.title,item.title_en)}}</div></div>
                            <div class="editor2" v-html="$common.langinfo(item.content,item.content_en)"></div>
                            <div class="infosubmore" v-if="item.url"><a :href="item.url" target="_blank" class="infomore">{{$common.dicword('more')}}</a></div>
                        </div>
                        <div class="infosub2 infosubimg">
                            <img :src="item.imgs" class="infosub2img" />
                        </div>
                    </template>
                    <div class="infosub3" v-else>
                        <div class="subtitle" v-if="item.parinfokindkv!=9"><div class="word">{{$common.langinfo(item.title,item.title_en)}}</div></div>
                        <div class="editor2" v-html="$common.langinfo(item.content,item.content_en)"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ffinfo',
        data() {
            return {
                footerinfo: ''
            }
        },
        props: {
            infolist: {
                type: Array,
                default: () => []
            }
        }
    };
</script>
